module.exports = __webpack_public_path__ + "static/media/Republic of North Macedonia - MK.3691ee3b.png";